// Import React and Hooks
import React, { useState } from 'react'



// Accordion Item prop
interface accordionItemProp {
  accordionItem: {
    title:string,
    content:string
  }
  additionalClass?:string
}

const AccordionItem = ( { accordionItem, additionalClass }:accordionItemProp ) => {



  // Use state
  const [ isOpen, setIsOpen ] = useState( false )



  // Functions
  function handleToggleAccordionItem() {
    setIsOpen( isOpen ? false : true )
  }



  return (
    <article className={`accordion__item ${ isOpen ? 'active' : '' } ${ additionalClass ? additionalClass : ''}`}>
      <header
        className="accordion__item__header"
        onClick={ () => handleToggleAccordionItem() } >
        <h3 className="accordion__item__title">
          { accordionItem.title }
        </h3>
      </header>
      <div
        className="accordion__item__content"
        dangerouslySetInnerHTML={{ __html: accordionItem.content }} />
    </article>
  )
}




export default AccordionItem


{/* BEER MASK */}
{/* <section className={`beerMask ${ turnedBeer ? 'turned' : '' } mbM40`}>
<div className="beerMask__clean">
  <img src={`${window.assetsURl}/imgs/product/beer-clean.png`} alt="" className="beerMask__clean__img" />
</div>
<div className="beerMask__front">
  <img src={`${window.assetsURl}/imgs/product/beer-front.png`} alt="" className="beerMask__front__img" />
  <img src={ fileImg } alt="" className="beerMask__front__photo" />
</div>
<div className="beerMask__back">
  <img src={`${window.assetsURl}/imgs/product/beer-back.png`} alt="" className="beerMask__back__img" />
  <p className="beerMask__text">
    { textDedication }
  </p>
</div>
<div className="beerMask__controls">
  <button
    type="button"
    className="beerMask__btn"
    onClick={ () => setTurnedBeer( turnedBeer ? false : true ) } >
    Girar Lata
  </button>
</div>
</section> */}
{/* END BEER MASK */}
